import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import {
  ExercisesCreateInterface,
  ExercisesInterface,
  GetExercisesIdInterface,
} from "../types/types";

export const exercises = {
  createExercises: (body: ExercisesCreateInterface) => {
    return HttpClient.post<ExercisesCreateInterface>(
      API_ENDPOINTS.EXERCISES,
      body
    );
  },
  UpdateExercises: (body: ExercisesCreateInterface, id: number) => {
    return HttpClient.put<ExercisesCreateInterface>(
      `${API_ENDPOINTS.EXERCISES}/${id}`,
      body
    );
  },
  deleteExercises: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.EXERCISES}/${id}`);
  },
  GetExercises: (options?: any) => {
    return HttpClient.get<ExercisesInterface>(API_ENDPOINTS.EXERCISES, options);
  },
  GetExercisesById: (id: number) => {
    return HttpClient.get<GetExercisesIdInterface>(
      `${API_ENDPOINTS.EXERCISES}/${id}`
    );
  },
};
